import React, { useState } from 'react';
import styled from 'styled-components';
import logo from "../assets/logo.png";
import { useNavigate } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';



const EditRoleModal = ({ email, currentRole, onClose, onRoleUpdated }) => {
    const [newRole, setNewRole] = useState(currentRole);

    const handleSubmit = async () => {
        const res = await fetch('/api/update_user_status_and_role', { //new /update_user_role
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            // body: JSON.stringify({ email, role: newRole })
            body: JSON.stringify({ email, role: newRole, status: 'active' })
        });

        if (res.ok) {
            onRoleUpdated();
            onClose();
        } else {
            alert('Failed to update role');
        }
    };

    return (
        // Modal backdrop and centering
        <div
            className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center"
            style={{ zIndex: 1050 }}
        >
            <div
                className="bg-white p-4 rounded-3 shadow"
                style={{ width: '300px' }}
                role="dialog"
                aria-modal="true"
            >
                <h3>Update Role</h3>
                <p><strong>{email}</strong></p>
                <select
                    className="form-select my-3"
                    value={newRole}
                    onChange={(e) => setNewRole(e.target.value)}
                >
                    <option value="Admin">Admin</option>
                    <option value="Editor">Editor</option>
                    <option value="Viewer">Viewer</option>
                </select>
                <div className="d-flex justify-content-end gap-2">
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        Update
                    </button>
                    <button className="btn btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditRoleModal;
